import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaugeChartComponent } from './gauge-chart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { GaugeChartRoutingModule } from './gauge-chart-routing.module';

import {
  NbButtonModule,
  NbCardModule,
  NbDatepickerModule,
  NbFormFieldModule,
  NbIconModule,
  NbLayoutModule,
  NbSelectModule
} from '@nebular/theme';

import { NbEvaIconsModule } from '@nebular/eva-icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExcellentGaugeChartComponent } from './excellent-gauge-chart/excellent-gauge-chart.component';
import { OkGaugeChartComponent } from './ok-gauge-chart/ok-gauge-chart.component';
import { NotOkGaugeChartComponent } from './not-ok-gauge-chart/not-ok-gauge-chart.component';
import { NbDateFnsDateModule } from '@nebular/date-fns';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    NgxEchartsModule,
    GaugeChartRoutingModule,

    // remove .forRoot()
    NbLayoutModule,
    NbEvaIconsModule,
    NbSelectModule,
    NbButtonModule,
    NbIconModule,
    FormsModule,
    NbFormFieldModule,
    NbCardModule,
    ReactiveFormsModule,
    NbDatepickerModule.forRoot(),
    NbDateFnsDateModule.forRoot({
      format: 'dd MMM yy' // GLOBAL FORMAT HERE
    }),
  ]
})
export class GaugeChartModule {}
